/*
 * Feature keys should be added to this file like:
 *
 * ```
 * const featureKeys = Object.freeze({
 *   FEATURE_FLAG_NAME: 'domain.subdomain.feature',
 * });
 * ```
 */

const featureKeys = Object.freeze({
  WORKSPACE_GRADES_NEW_DESIGN: 'workspace.grades.newDesign',
  WORKSPACE_RELEASE_NOTES: 'workspace.releaseNotes',
  WORKSPACE_COMPONENT_GUIDE: 'workspace.componentGuide',
  WORKSPACE_PROJECTS_SETTINGS: 'workspace.projects.settings',
  WORKSPACE_SIDEBAR_NON_SEQUENTIAL_NAVIGATION: 'workspace.sidebarNonSequentialNavigation',
  WORKSPACE_ALFRESCO_SYNC: 'workspace.alfresco.sync',
  WORKSPACE_ALFRESCO_REFRESH: 'workspace.alfresco.refresh',
  WORKSPACE_ALFRESCO_FILE_PICKER: 'workspace.alfresco.file.picker',
  WORKSPACE_ACTIVITY_DUPLICATE: 'workspace.activity.duplicate',
  WORKSPACE_COURSE_EXPORT_REPORT: 'workspace.course.export.report',
  WORKSPACE_COMBINED_FEEDBACK: 'workspace.combinedFeedback',
  WORKSPACE_MATHJAX_EDITOR: 'workspace.mathjaxEditor',
  WORKSPACE_EPUB_PREVIEW: 'workspace.epub.preview',
  WORKSPACE_EPUB_COURSE_PREVIEW: 'workspace.epub.course.preview',
  WORKSPACE_EPUB_LESSON_PREVIEW: 'workspace.epub.lesson.preview',
  WORKSPACE_EPUB_SCREEN_PREVIEW: 'workspace.epub.screen.preview',
  BRNT_18708_WORKSPACE_EPUB_COURSE_PREVIEW_PERCENTAGE_LOADER: 'BRNT_18708_workspace_epub_course_preview_percentage_loader',
  WORKSPACE_EPUB_COMPONENTS_FILTER: 'workspace.epub.components.filter',
  WORKSPACE_PUBLICATIONS_INTERFACE: 'workspace.publications.interface',
  WORKSPACE_IMPORT_EPUB: 'workspace.import.epub',
  WORKSPACE_IMPORT_STUDYCHANNEL: 'BRNT_18501_ms_word_stud_chanels_import',
  WORKSPACE_SCENARIO_CONDITIONS_SELECTOR_WITH_SIBLING_SCOPE: 'workspace.scenarioConditionsSelectorWithSiblingScope',
  WORKSPACE_PUBLICATION_CHANNEL_PARTNER: 'workspace.publication.channelPartner',
  AUTHORING_SPF_ENTRANCE_ANIMATION: 'authoring-spf-entrance-animation',
  WORKSPACE_CLASS_LTI_ENROLLMENT: 'workspace.class.lti.enrollment',
  AUTHORING_IMAGE_BACKGROUNG_PARALLAX: 'authoring-image-background-parallax',
  WORKSPACE_KNOWLEDGE_MAPS: 'workspace.knowledge.maps',
  WORKSPACE_IMPORT_WORD_CHAPTER: 'workspace.import.word.chapter',
  WORKSPACE_ACTIVITY_DUPLICATE_DEEPCOPY: 'workspace.activity.duplicate.deepcopy',
  PROJECT_ACTIVITY_DUPLICATE_DEEPCOPY: 'project.activity.duplicate.deepcopy',
  WORKSPACE_LEARNING_ACTION_TAG_OBJECTIVES: 'workspace.learning.action.tag.objectives',
  WORKSPACE_AUTHORING_ACTIVITY_EDITOR: 'workspace.authoring.activity.editor',
  INLINE_DROPDOWN_DEFECT_BRNT_12234: 'inline-dropdown-defect-brnt-12234',
  WORKSPACE_CONFIG_RESOLVER: 'workspace.config.resolver',
  AUTHORING_BINDING_REAL_VALUE: 'authoring-BRNT-12940',
  AUTHORING_SELECT_ALL_RESPONSES: 'authoring-select-all-responses',
  BRONTE_SPF_2_IMPLEMENTATION: "bronte-spf-2-implementation",
  AUTHORING_SELECT_ALL_RESPONSES_EDIT: 'authoring-select-all-responses-edit',
  CONTENT_CREATION_INLINE_IMAGE_EDITOR: "content-creation-inline-image-editor",
  COMMENT_AGGREGATION_AND_COLLABORATIVE_EDITING: "comment-aggregation-and-collaborative-editing",
  WORKSPACE_REDESIGN: 'workspace.redesign',
  WORKSPACE_BV_EPUB_IMPORT: 'workspace.bv.epub.import',
  WORKSPACE_PUBICATION_OUTPUT_TYPE_CHANNEL_PARTNER: 'workspace.pubication.outputtype.channelpartner',
  WORKSPACE_PUBLICATIONS_CLASSONDEMAND: 'workspace.publications.classondemand',
  WORKSPACE_PUBLICATIONS_PEARSON_PLUS_ETEXT: 'workspace-publications-pPlus-eText',
  BRNT_18784_WORKSPACE_ERROR_REPORT_PERCENTAGE_LOADER: 'BRNT_18784_workspace_error_report_percentage_loader',
  WORKSPACE_PUBLICATIONS_BV_TEST_ONLY: 'workspace-publications-bv-test-only',
  WORKSPACE_PUBLICATIONS_INDESIGN: 'workspace.publications.indesign',
  BRNT_18710_WORKSPACE_REDESIGN_22: 'BRNT_18710_workspace_redesign_22',
  BRONTE_CONTENT_DELETE_CONFIRMATION: 'bronte-content-delete-confirmation',
  WORKSPACE_SCENARIO_ACTION_GRADEPASSBACK: 'workspace.scenario.action.gradePassback',
  ENABLE_COMMENTING_RESOLVE: 'enable-commenting-resolve',
  DISPLAY_CREATED_DATE_PROJECT_VIEW: 'workspace.courseware.project.display-created-date-projectview',
  WORKSPACE_PUBLICATION_ADDMODAL_DISPLAYPROJECTLIST: 'workspace.publication.addModal.displayProjectsList',
  COMMENT_AGGREGATION_AND_COLLABORATIVE_EDITING_POP_UP_SUMMARY: 'comment-aggregation-and-collaborative-editing-pop-up-summary',
  BRNT_17179_COPY_PASTE_INCONSISTENCY_FIX: 'BRNT-17179_copy_paste_inconsistency_fix',
  FEATURE_FLAG_BRNT_19838_WORKSPACE_ALERT_BANNER_DO_NOT_DELETE: 'feature-flag-brnt-19838-workspace-alert-banner-do-not-delete',
  BRNT_19837_WORKSPACE_NOTIFICATION_BANNER_DO_NOT_DELETE: 'BRNT_19837_workspace_notification_banner_do_not_delete',
  INGESTION_AMBROSIA_FORMAT_OPTION: 'BRNT-20210-ingest-ambrosia',
  BRNT_22755_BRONTE_VIEWER_WORD_IMPORT: 'BRNT-22755-bronte-viewer-word-import',
  BRNT_19839_WORKSPACE_WARNING_BANNER_DO_NOT_DELETE: 'BRNT_19839_workspace_warning_banner_do_not_delete',
  WORKSPACE_PUBLICATION_THREE_LEVEL_TOC_OPTION: 'workspace.publication.threeleveltocoption',
  WORKSPACE_PUBLICATION_THREE_LEVEL_TOC_OPTION_BV: 'workspace.publication.threeleveltocoption.bv',
  WORKSPACE_PUBLICATION_GENERATE_URNS: 'workspace.publication.generate.urns',
  CORNUCOPIA_PHASE_ONE: 'cornucopia-app-phase-1',
  WORKSPACE_IES_V2: 'workspace-azure-ad',
  WORKSPACE_CONDITIONAL_CONTENT: 'workspace.conditional.content',
  WORKSPACE_CONDITIONAL_CONTENT_HIGHER_LEVELS: 'workspace.conditional.content.higherlevels',
  WORKSPACE_DUPLICATE_OPTIONS: 'workspace.duplicate.options',
  WORKSPACE_COPY_GENERATE_UNIQUE_LOCAL_REF_IDS: 'workspace.copy.generate.uniqueids',
  WORKSPACE_PUBLICATION_CHILD_ISBN: 'workspace.publication.child.isbn',
  WORKSPACE_ACTIVITY_LIST_OCULUS_STATUS: 'workspace.activity.list.withOculusStatus',
  WORKSPACE_CONDITIONAL_CONTENT_PREVIEW: 'workspace.conditional.previews',
  WORKSPACE_GEN_AI_ASSISTANT_CHAPTER_LESSON_SUMMARY: 'gen_ai_assistant_chapter_lesson_summary',
  WORKSPACE_GEN_AI_ASSISTANT_SUMMARY_PROMPT_EDIT: 'gen_ai_assistant_summary_prompt_edit',
  WORKSPACE_ALLOW_PUBLISHED_DELETION: 'workspace.allow.published.deletion',
  WORKSPACE_ACTIVITY_GET_ACTIVITY_STATUS: 'workspace.activity.get.activitystatus',
  WORKSPACE_PUBLICATIONS_VERSION_COMPARISON: 'workspace.publication.version.comparison',
  WORKSPACE_PUBLICATION_LOCKTOC: 'workspace.publication.lockTOC',
  WORKSPACE_PROJECTS_PUBLICATION_DETAILS_TAB: 'workspace.projects.publication.details',
  WORKSPACE_ALFRESCO_REMEMBER_FOLDER: 'workspace.alfresco.remember.folder',
  WORKSPACE_MARKET_DERIVATIVES: 'workspace.market.derivatives',
  WORKSPACE_FORCE_ALLOW_PUBLISH: 'workspace.force.allow.publish',
  WORKSPACE_TRANSLATIONS: 'workspace.translations',
  WORKSPACE_DISPLAY_ALL_CLASSES: 'workspace.display.all.classes',
  WORKSPACE_TRANSLATIONS_COURSE_POC: 'workspace.translations.course.poc',
  BPRT_454_SPP2_VIDEO_PLAYER_COMPONENT: 'BPRT-454_SPP2_Video_Player_Component',
  WORKSPACE_IMPORTPILL_ONPROJECTLIST: 'workspace.importpill.onprojectlist',
  LEARNING_OBJECTIVE_DASHBOARD: 'learning.objective.dashboard',
});

export default featureKeys;
